import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Condolence\GetCondolenceListController::__invoke
* @see app/Http/Controllers/Condolence/GetCondolenceListController.php
* @route '/api/condolence'
*/
const GetCondolenceListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCondolenceListController.url(options),
    method: 'get',
})

GetCondolenceListController.definition = {
    methods: ["get","head"],
    url: '/api/condolence',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Condolence\GetCondolenceListController::__invoke
* @see app/Http/Controllers/Condolence/GetCondolenceListController.php
* @route '/api/condolence'
*/
GetCondolenceListController.url = (options?: RouteQueryOptions) => {
    return GetCondolenceListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Condolence\GetCondolenceListController::__invoke
* @see app/Http/Controllers/Condolence/GetCondolenceListController.php
* @route '/api/condolence'
*/
GetCondolenceListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCondolenceListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Condolence\GetCondolenceListController::__invoke
* @see app/Http/Controllers/Condolence/GetCondolenceListController.php
* @route '/api/condolence'
*/
GetCondolenceListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCondolenceListController.url(options),
    method: 'head',
})

export default GetCondolenceListController